var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    _vm._b({ attrs: { placement: "top" } }, "el-tooltip", _vm.attr, false),
    [
      !_vm.content
        ? _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [_vm._t("content")],
            2
          )
        : _vm._e(),
      _c(
        "el-button",
        {
          staticClass: "z-button--icon",
          attrs: { type: "text" },
          on: { click: _vm.clickHandler },
        },
        [_c("i", { staticClass: "iconfont", class: _vm.icon })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }